import { render, staticRenderFns } from "./AdminContentItemSendToCompleted.vue?vue&type=template&id=4a2a2364&"
import script from "./AdminContentItemSendToCompleted.vue?vue&type=script&lang=ts&"
export * from "./AdminContentItemSendToCompleted.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTooltip,QSpinnerDots});
